export const scrollTo = (container, { top = 0, left = 0, behaviour = 'instant' }) => {
  container.scrollTo({
    top: top,
    left: left,
    behavior: behaviour
  })
}